/* eslint-disable react/jsx-props-no-spreading */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import * as AppPropTypes from '../../lib/PropTypes';

// import { getComponentFromName } from '../../lib/utils';
// import { sections as sectionImages } from '../../../img/sections/index';
// import * as Icons from '../icons/sections/index';
import CardLayout from '../partials/CardLayout';
// import Image from '../partials/Image';
import Link from '../partials/Link';

import styles from '../../../styles/cards/section-preview.module.scss';

// import globe from '../../../img/sections/2024/competition-internationale.svg';

const propTypes = {
    item: AppPropTypes.article.isRequired,
    withDescription: PropTypes.bool,
    className: PropTypes.string,
};

const defaultProps = {
    withDescription: false,
    className: null,
};

const SectionPreviewCard = ({ item, withDescription, className }) => {
    const {
        title = null,
        shortTitle = null,
        url = null,
        description = null,
        // slug = null,
        // handle = null,
        summary = null,
        lengths = null,
    } = item || null;

    // const image = sectionImages.find(({ id }) => handle.includes(id));
    const isShorts = (lengths || []).includes('short');

    // const noHyphenHandle = handle.replace(/-/g, '');
    // const noTypeHandle = noHyphenHandle.replace('courtmetrage', '').replace('shortfilm', '');
    // let IconComponent = null;
    // if (isShorts && slug !== null) {
    //     IconComponent = getComponentFromName(Icons, noTypeHandle, 'louve');
    // }

    const inner = (
        <CardLayout
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                    [styles.isShorts]: isShorts,
                },
            ])}
            type="section"
            withoutPlaceholder
            url={url}
        >
            {/* {isShorts && IconComponent !== null ? (
                <IconComponent className={styles.icon} />
            ) : (
                <Image
                    imageClassName={styles.image}
                    media={image !== null ? { url: image?.img } : { url: globe }}
                />
            )} */}
            <div className={styles.content}>
                {summary !== null ? <h4 className={styles.surtitle}>{summary}</h4> : null}
                {title !== null && shortTitle !== null ? (
                    <h3 className={styles.title}>{shortTitle || title}</h3>
                ) : null}
                {withDescription && description !== null ? (
                    <h4 className={classNames(styles.info, styles.description)}>{description}</h4>
                ) : null}
            </div>
        </CardLayout>
    );

    return url !== null ? (
        <Link href={url} className={styles.link}>
            {inner}
        </Link>
    ) : (
        inner
    );
};

SectionPreviewCard.propTypes = propTypes;
SectionPreviewCard.defaultProps = defaultProps;

export default SectionPreviewCard;
